import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import Home from './Home';

const Navbar = () => {
    const navigate = useNavigate();

    return (  
        <nav className="navbar">
            <img 
                src="/logo2.png"
                alt="Haaskel Logo"
                className="logo"
                onClick={() => navigate('/home')}
            />

            <div className="navbar-tabs">
                <button onClick={() => navigate('/home')}>Home</button>
                <button onClick={() => navigate('/services')}>Services</button>
                <button onClick={() => navigate('/aboutus')}>About Us</button>
                <button onClick={() => navigate('/consultation')}>Contact Us</button>
            </div>
        </nav>
    );
}
 
export default Navbar;
